import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'set_connection_status',
  stateProp: 'connectionStatus',
  defaultState: {
    connectionStatus: {
      connected: true,
      shownError: false
    }
  },
  handler({ connected, shownError }) {
    return {
      connectionStatus: {
        connected,
        shownError
      }
    };
  },
  reduce(state, { connectionStatus }) {
    return {
      connectionStatus
    };
  }
});
